<template>
    <div class="container is-max-widescreen has-bg-white py-5">
        <Header/>
        <div class="columns">
            <div class="settings-section column has-background-white rounded-2 column p-0 is-3">
                <aside class="menu pb-5">
                    <p class="title p-3 mb-3 pt-6 ml-3">
                        {{$t('settings')}}
                    </p>

                    <ul class="menu-list">
                        <router-link to="/brandSettings">
                            <li>
                                <a>
                                    {{$t('brand_settings')}} 
                                </a>
                            </li>
                        </router-link>
                        <router-link to="/vendorSettings">
                            <li>
                                <a>
                                    {{$t('vendor_settings')}} 
                                </a>
                            </li>
                        </router-link>
                        <router-link to="/languagePreference">
                            <li>
                                <a>
                                    {{$t('lang_preference')}} 
                                </a>
                            </li>
                        </router-link>
                    </ul>

                </aside>
            </div>
            <div class="main-section column has-background-white rounded-2 column pt-6 pl-5 is-9">
                <h1 class="title is-3 pl-2 is-flex">
                    
                    {{$t('brand_settings')}}

                    <section class="b-tooltips ml-5">
                        <b-tooltip position="is-right" type="is-white" :triggers="['click']" :auto-close="['outside', 'escape']" multilined>
                            <i class="mdi mdi-alert-circle" style="color: #858C94; transform: scale(0.5);"></i>
                            <template v-slot:content>
                                 <h1 class="brand-desc is-size-6 ml-2 w-100" v-html="$t('brand_tooltip')"></h1>
                            </template>
                        </b-tooltip>
                    </section>
                </h1>

                <h1 class="is-size-6 mb-5 pl-2" v-html="$t('brand_desc')"></h1>

                <div class="p-2">
                    <b-table
                        :data="brands"
                        bordered
                        :sticky-header="true"
                        class="import-history-table"
                        >

                        <b-table-column field="brand_code" :label="$t('brand')" v-slot="props">
                            <span>
                                {{ props.row.name | filterName }}
                            </span>
                        </b-table-column>

                        <b-table-column field="iys_no" :label="$t('iys_code')" v-slot="props">
                            <span>
                                {{ props.row.brand_code}}
                            </span>
                        </b-table-column>

                        <template #empty>
                            <div  class="p-4" v-html="$t('no_brands')"></div>
                        </template>

                    </b-table>

                </div>
            </div>
        </div>
    </div>
</template>



<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapActions,mapGetters } from 'vuex'
import Header from './Header'


export default {
    name:'Home',
    components: {
        Header,
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            brand_codes:[],
        }
    },
    computed:{
        ...mapGetters(['brands']),
    },
    methods: {
        ...mapActions(['getBrands']),
    },
    created() {
        this.getBrands()
    },
    filters: {
        filterName:function(value){
            if ( value.length > 50 ) {
                return value.substring(0,50) + '...'
            } else {
                return value
            }
        }
    }
}
</script>

<style scoped>
    .settings-section{
        height: 100%;
        margin-right: 2rem;
    }
    .main-section{
        min-height: 35vh;
    }
    @media(max-width: 800px){
        .settings-section{
            margin-right: 0;
            margin-bottom: 2rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/BrandSettings.vue